import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: any) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'hidden',
    background: '#141414',
    minHeight: 'calc(100vh - 56px)',
    borderRadius: 0,
  },
  titleWrapper: {
    width: '100%',
    padding: 20,
    textAlign: 'center',
    borderBottom: '1px solid #929292',
    position: 'relative',
  },
  title: {
    fontSize: '20px',
    lineHeight: '23px',
  },
  main: {
    width: '100%',
    padding: '16px 0',
    position: 'relative',
  },
  card: {
    backgroundColor: theme.backgrounds.cardBackground,
    padding: '3% 10%',
    marginBottom: 22,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '5px',
    minHeight: 100,
  },
  blockTitle: {
    color: theme.scenes.textColor,
    fontSize: '18px',
    marginBottom: 5,
  },
  blockType: {
    fontSize: '18px',
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  subTitle: {
    fontSize: '14px',
    marginTop: 10,
  },
  infoIcon: {
    position: 'absolute',
    left: '5%',
    top: '50%',
    marginTop: '-12px',
    cursor: 'pointer',
  },
  webView: {
    background: theme.webView.background,
  },
}))

export default useStyles
